import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';
import { Injectable } from '@angular/core';
import * as HttpStatus from 'http-status-codes';
import { AuthenticationStore } from '../../permission/services/authentication.store';
import { ResponseUtil } from './response-util';
import { LogService } from '../log/log.service';
import { FlashMessagesService } from '../flash-messages/service/flash.messages.service';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class ResponseUtilService {
  constructor(
    private authStore: AuthenticationStore,
    private logService: LogService,
    private flashMessagesService: FlashMessagesService) {
  }

  handleError(response: Response | Error): Observable<Response> {
    if ((response instanceof Response && (<Response>response).status === HttpStatus.UNAUTHORIZED)
      || response instanceof Error) {
      this.authStore.logout();
      this.logService.warn('Logging out due to AuthHttp error or invalid JWT token');
      this.logService.warn(response.toString());
      // return empty since we handled the error
      return Observable.empty();
    } else if (response instanceof Response && (<Response>response).status === HttpStatus.INTERNAL_SERVER_ERROR) {
      let _response = <Response>response;
      let errorResponse: string = <string>_response['_body'];
      if (errorResponse && errorResponse.includes('vendor email address is missing for this request')) {
        this.flashMessagesService.error('MESSAGES.ERROR.VENDOR_EMAIL_MISSING', errorResponse);
      } else {
        this.flashMessagesService.error('MESSAGES.ERROR.INTERNAL_SERVER_ERROR', 'An unexpected error has occurred');
      }

      return Observable.empty();
    } else if ( !(response instanceof Response) && (<Response>response).status === HttpStatus.BAD_REQUEST) {
      let errorResponse = <HttpErrorResponse >response;
      if ( errorResponse.error.includes('Unable to request final payment.')) {
        this.flashMessagesService.error('MESSAGES.ERROR.OOIV_HEALTH', 'An unexpected error has occurred');
      } else {
      this.flashMessagesService.error('MESSAGES.ERROR.INTERNAL_SERVER_ERROR', 'An unexpected error has occurred');
      }
      return Observable.empty();
    } else if ( !(response instanceof Response) && (<Response>response).status === HttpStatus.FORBIDDEN) {
      let errorResponse = <HttpErrorResponse >response;
      if (errorResponse.error.includes('Invalid Tax ID')) {
        this.flashMessagesService.error('MESSAGES.ERROR.INVALID_VAT_ID', 'An unexpected error has occurred');
      } else {
      this.flashMessagesService.error('MESSAGES.ERROR.INTERNAL_SERVER_ERROR', 'An unexpected error has occurred');
      }
      return Observable.empty();
    }else { // must be Response without status code 401
      return ResponseUtil.unwrapErrorMessage(response);
    }
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/utils/response-util.service.ts